/**
 * @file
 * Upload Configuration
 * Used in library: vue-upload-component
 *
 * This file provides the standard configuration of uploading a file
 * See https://lian-yue.github.io/vue-upload-component/#/en/documents
 */

import {FileFormat} from '@/enums/FileFormat'
import {UploadConfig as UploadConfigWrapper, Dictionary} from 'simpli-web-sdk'

export class UploadConfig extends UploadConfigWrapper {
  /**
   * Data preset
   */
  static buildDataPreset(maximum?: number) {
    const config = new UploadConfig(maximum)
    config.accept = '.csv, .xml, .xls, .xlsx, .txt'
    config.extensions = [FileFormat.CSV, FileFormat.XML, FileFormat.XLS, FileFormat.XLSX, FileFormat.TXT]

    return config
  }

  /**
   * Image preset
   */
  static buildImagePreset(maximum?: number) {
    const config = new UploadConfig(maximum)
    config.accept = 'image/png, image/jpeg, image/jpg'
    config.extensions = [FileFormat.PNG, FileFormat.JPEG, FileFormat.JPG]

    return config
  }

  /**
   * Document preset
   */
  static buildDocumentPreset(maximum?: number) {
    const config = new UploadConfig(maximum)
    config.accept = 'image/png, image/jpeg, image/jpg, .pdf'
    config.extensions = [FileFormat.PNG, FileFormat.JPEG, FileFormat.JPG, FileFormat.PDF]

    return config
  }

  /**
   * Data preset - Import
   */
  static buildImportDataPreset(maximum?: number) {
    const config = new UploadConfig(maximum)
    config.accept = '.csv, .xml, .xls, .xlsx, .txt'
    config.extensions = [FileFormat.CSV, FileFormat.XML, FileFormat.XLS, FileFormat.XLSX, FileFormat.TXT]
    config.endpoint = '/user/upload-url/import'

    return config
  }

  endpoint = '/user/upload-url'
  headers: Dictionary<String> = {
    'Content-Type': 'application/octet-stream',
  }
}
